// extracted by mini-css-extract-plugin
export default {"main":"Alternance_main__cC0Ie","container":"Alternance_container__3Ydg+","container2":"Alternance_container2__f7Ogf","body":"Alternance_body__INFqw","page":"Alternance_page__SVpWI"};